import React from "react";
import { Arrow } from "../assets/Arrow";
import { colors } from "../variables";

export default function Button({
  children,
  style,
  withArrow = true,
  ...props
}) {
  return (
    <button
      {...props}
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "transparent",
        fontWeight: "600",
        fontSize: "1rem",
        color: colors.blue,
        border: "none",
        borderRadius: "5px",
        padding: "8px",
        ...style,
      }}
    >
      {children}
      {withArrow && (
        <span
          style={{
            display: "inline-block",
            padding: "0.25rem",
            width: "1rem",
            height: "1rem",
            marginLeft: "0.5rem",
            borderRadius: "50%",
            background: colors.blueGradient,
          }}
        >
          <Arrow />
        </span>
      )}
    </button>
  );
}
